import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import classNames from 'classnames';

import { FormInput } from 'Shared/components';
import { FormValuesType } from 'QuoteApp/services/endpoints/GetDetails';
import { GetVehicleByExactVinResponseType } from 'QuoteApp/components/VehiclesList/VehicleSelection';

import styles from './styles.module.css';

type VehicleMultiselectType = {
  vehicleId: string;
  data: GetVehicleByExactVinResponseType[];
  layout?: 'columns';
  hasError?: boolean;
  onChange?: () => void;
};

export const VehicleMultiselect: FC<VehicleMultiselectType> = ({
  vehicleId,
  data,
  layout,
  hasError,
  onChange,
}) => {
  const { values, setValues } = useFormikContext<FormValuesType>();

  if (!data.length) {
    return null;
  }

  const selectedVehicle = values.vehicles[vehicleId];

  return (
    <div className={styles.multiselectContainer}>
      <div className={styles.multiselectHeading}>Multiple VIN Matches</div>
      <div className={styles.multiselectLabel}>
        Please select the correct vehicle below
      </div>
      <div
        className={classNames({
          [styles.multiselectColumns]: layout === 'columns',
        })}
      >
        {data.map(vehicle => (
          <FormInput
            key={vehicle.vehicle_services_id}
            className={styles.multiselectRadio}
            indicatorClassName={classNames({
              [styles.indicatorHasError]: hasError,
            })}
            name="vehicle-multiselect"
            variant="radio"
            data-testid={`vehicle-multiselect-${vehicle.vehicle_services_id}`}
            label={
              <>
                <div className={styles.multiselectHeading}>
                  {`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
                </div>
                <div className={styles.multiselectLabel}>
                  {`Body Style: ${vehicle.body_style}`}
                </div>
              </>
            }
            value={vehicle.vehicle_services_id}
            checked={
              vehicle.vehicle_services_id === selectedVehicle?.vehicleServicesId
            }
            onChecked={() => {
              setValues({
                ...values,
                vehicles: {
                  ...values.vehicles,
                  [vehicleId]: {
                    ...values.vehicles[vehicleId],
                    year: vehicle.year.toString(),
                    make: vehicle.make,
                    model: vehicle.model,
                    bodyStyle: vehicle.body_style,
                    vehicleServicesId: vehicle.vehicle_services_id,
                    partialVin: vehicle.partial_vin,
                  },
                },
              });
              onChange?.();
            }}
          />
        ))}
      </div>
    </div>
  );
};
